export const parseFiltersFromUrl = () => {
  const params: URLSearchParams = new URLSearchParams(window.location.search)
  const filters = []
  params.forEach((value: string, filter: string) => {
    filters.push({
      filter,
      value,
    })
  })

  return filters
}
